module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAA/UlEQVR4AexUQQrCMBBsfFr7Bm8i3hRRELwLPkA8KKInD+LNL7Rfi7thU4YkEFcroigus83O7DTZ0F7x5t/fIHvAySOqqmpNYTHCTliT/Bhy+DkyKMtyS4UVhfY/Ju0uFEUGxpgFk+q6Nhi8hoE1zrlG2hkjRmSAxS7yHzKQm2DlWK6CGnCaoE+ROqINDW2g6cxc0Rw4x0gZYP3lPGWwpG2etZ1FMw11rQFt0d17IYwENeA0QZ/kDDRNs9x2B1nmk4SPGJz4ZWloqq8pa6y1F0aMaAc0pAkR90h6ML81TTMMuZEBE4g4JyN3qzzyOoZfB+xj3edJA1/sAr/f4A4AAP//qSheYAAAAAZJREFUAwCv/nYxNIvirQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/data_object.png
// module id = rL5O
// module chunks = 4